import axios from "axios";

const API_BASE_URL = "/api/business";

/**
 * Business API Service
 * Handles all HTTP requests related to business operations
 */
class BusinessService {
  /**
   * Create or update business
   */
  async createOrUpdateBusiness(businessData) {
    try {
      const hasFileUpload = businessData.companyLogo instanceof File || businessData.authorizedSignature instanceof File;
      if (hasFileUpload) {
        const formData = new FormData();
        Object.keys(businessData).forEach((key) => {
          if (key === "companyLogo" && businessData[key]) {
            formData.append("companyLogo", businessData[key]);
          } else if (key === "authorizedSignature" && businessData[key]) {
            formData.append("authorizedSignature", businessData[key]);
          } else if (key !== "companyLogo" && key !== "authorizedSignature" && key !== "companyLogoPreview" && key !== "authorizedSignaturePreview") {
            const val = businessData[key];
            formData.append(key, val !== null && val !== undefined ? val : "");
          }
        });
        if (businessData.removeAuthorizedSignature) {
          formData.append("removeAuthorizedSignature", "true");
        }
        const response = await axios.post(`${API_BASE_URL}/my`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
      } else {
        // For regular JSON data
        const response = await axios.post(`${API_BASE_URL}/my`, businessData, {
          headers: { "Content-Type": "application/json" },
        });
        return response.data;
      }
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update business
   */
  async updateBusiness(businessData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/my`, businessData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get my business
   */
  async getMyBusiness() {
    try {
      const response = await axios.get(`${API_BASE_URL}/my`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get business by ID
   */
  async getBusinessById(businessId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${businessId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete business
   */
  async deleteBusiness(businessId) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${businessId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data?.message || "An error occurred",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      return {
        message: "Network error. Please check your connection.",
        status: 0,
      };
    } else {
      return {
        message: error.message || "An unexpected error occurred",
        status: 0,
      };
    }
  }
}

const businessService = new BusinessService();
export default businessService;

